import React, { useState} from "react";
import { useParams } from "react-router-dom";
//import { Identity } from "../../../components/Identity";
import { PageTopbar } from "../../../components/Page/Topbar";
import { PageHeader } from "../../../components/Page/Header";
import { AppRentalsCasesDetails } from "../../../app/Rentals/Cases/Details";
import { getPageTitle} from "../../../app/helpers/global";

export function RoutesRentalsCasesDetails({ parents, current }) {

    const { rentalCaseId } = useParams();
    const [ title, setTitle] = useState(null);

    let group = (parents).replaceAll('/', '-');
    if (title === null) {
        getPageTitle('rental', rentalCaseId, setTitle);
    }

    return (
        <div>
            <PageTopbar
                parents={parents}
                current={current}
            />

            {/* <Identity /> */}

            <PageHeader
                title={title}
                parents={parents}
                current={current}
                variables={{ rentalCaseId: rentalCaseId }}
                tabGroup={group}
            />

            <AppRentalsCasesDetails
                rentalCaseId={rentalCaseId}
                setTitle={setTitle}
            />
        </div>
    );
}